<template lang="pug">
  li.tree-item(:class="{ 'is-parent': children.length, 'is-enough': is >= should }")
    slot(name="item" :item="item" :depth="depth" :style="style")
      label.label(:for="`category-percentage-${item.id}`" :style="style")
        nobr {{ item.name }}
      template(v-if="info !== true")
        .input(:style="style")
          slot
          input(
            :id="`category-percentage-${item.id}`"
            type="number"
            v-model="percentage"
          )
        .should {{ should | moneyFormat(currency) }}
        .is {{ is | moneyFormat(currency) }}
      template(v-else)
        .qty {{ qty }} St.
        .sum {{ is | moneyFormat(currency) }}
    ProductCategoryTree(
      v-if="children.length"
      :info="info"
      :tree="children"
      :depth="depth + 1"
      :data="data"
      :budget="should"
      :currency="currency"
    )
      template(v-slot:item="{ item, depth, style }")
        slot(name="item" :item="item" :depth="depth" :style="style")
</template>

<script>
import { get } from '@/helpers';
import { mapGetters } from 'vuex';

export default {
    name: 'ProductCategoryTreeItem',
    props: {
        item: {
            type: Object,
            required: true
        },
        data: {
            type: Object,
            default: () => ({})
        },
        budget: {
            type: Number,
            default: 0
        },
        currency: {
            type: String,
            default: 'EUR'
        },
        depth: {
            type: Number,
            required: true
        },
        info: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        style() {
            let style = {};
            if (this.depth > 1) {
                style['padding-left'] = `${(this.depth - 1) * 20}px`;
            }
            return style;
        },
        children() {
            let children = [];
            if (this.item.children && this.item.children.length) {
                children = this.item.children;
            }
            return children;
        },
        should() {
            return (this.budget / 100) * this.percentage;
        },
        qty() {
            let childQty = 0;

            const walkChildren = (children, cb) => {
                if (children && children.length) {
                    children.forEach(el => {
                        if (el.children && el.children.length) walkChildren(el.children, cb);
                        cb(el);
                    });
                }
            };
            walkChildren(this.children, el => {
                if (el && el.id) {
                    const qty = get(this.data.quantities, el.id) || 0;
                    childQty += qty;
                }
            });

            return (get(this.data.quantities, this.item.id) || 0) + childQty;
        },
        is() {
            let childExpenses = 0;

            const walkChildren = (children, cb) => {
                if (children && children.length) {
                    children.forEach(el => {
                        if (el.children && el.children.length) walkChildren(el.children, cb);
                        cb(el);
                    });
                }
            };
            walkChildren(this.children, el => {
                if (el && el.id) {
                    const expense = get(this.data.expenses, el.id) || 0;
                    childExpenses += expense;
                }
            });

            return (get(this.data.expenses, this.item.id) || 0) + childExpenses;
        },
        percentage: {
            set(value) {
                value = parseFloat(value);

                let budgeting = JSON.parse(localStorage.getItem('budgeting-tool')) || {};
                if (!budgeting.percentages) budgeting.percentages = {};
                budgeting.percentages[this.item.id] = value;
                localStorage.setItem('budgeting-tool', JSON.stringify(budgeting));

                this.$set(this.data.percentages, this.item.id, value);
            },
            get() {
                // return this.panel.budget;
                return get(this.data, `percentages.${this.item.id}`) || 0;
            }
        },
        ...mapGetters({
            cart: 'shop/cart'
        })
    },
    methods: {
        hasSlot() {
            console.log(this.$slots);
            return true;
        }
    }
};
</script>

<style lang="sass" scoped>
.should, .is
  padding-left: 10px
  min-width: 80px
  justify-content: flex-end
  font-weight: bold
.label, .input, .should, .is
  display: flex
  align-items: center
.input
  flex-direction: column
  align-items: flex-start
input
  @apply rounded-none py-1 px-2 #{!important}
  width: 40px !important
  height: auto !important
  margin: 2px
.is-parent
  & > .is
    font-weight: normal
  & > .should
    font-weight: normal
    &:before
      content: '('
    &:after
      content: ')'

.is
  color: theme('colors.red.600')

.is-enough
  & > .is
    color: initial

.is-first
  & >
    .label, .should, .is
      padding-top: 20px

input[type=number]
  -moz-appearance: textfield

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button
  -webkit-appearance: none
  margin: 0
</style>
